/*

View shown if user logs into account that has not been set up.
Could occur if provisioning fails but more likely if they click an authprovider on the LOGIN page not JOIN page...
This is to remind them that they didn't sign in with this method before!

Can also display if login takes too long and user data is not received, so could be offline.

*/
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ServicesContext } from 'src/ServicesContext';
import R from 'src/routes';
import {
  NotProvisionedProps,
  NotProvisionedContainerProps,
} from './NotProvisioned.types';
import { NotProvisioned } from './NotProvisioned.component';
import { useHistory } from 'react-router-dom';
import { firestore_user_set_up_redux } from 'src/mvp22/redux-components/reducers/firestore_user_set_up';
import { RootState } from 'src';

const NotProvisionedContainer: React.FC<NotProvisionedContainerProps> = (
  props,
) => {
  /* Global state */
  const isSigningIn = useSelector<RootState, boolean>(
    ({ userData }) => userData.is_signing_in,
  );
  /* Local state */
  const [isProvisioning, setIsProvisioning] = React.useState(false);
  const [provisioningFailed, setProvisioningFailed] = React.useState(false);
  const [justLoggedIn] = React.useState(isSigningIn); // Just store the value on the mounting.

  /* Hooks + Contexts */
  const history = useHistory();
  const dispatch = useDispatch();
  const { auth, firebaseMVP22 } = React.useContext(ServicesContext);

  /* Handlers */
  const handleGoBack = React.useCallback<NotProvisionedProps['handleGoBack']>(
    (event) => {
      event.preventDefault();
      history.push(R.LOGOUT);
    },
    [history],
  );
  const handleProvisioning = React.useCallback<
    NotProvisionedProps['handleProvisioning']
  >(
    (event) => {
      event.preventDefault();
      setIsProvisioning(true);
      auth
        .provisionWithCurrentCredentials()
        .then((user) => {
          if (user) {
            return dispatch(
              firestore_user_set_up_redux({
                auth_user_uid: user.uid,
                firebase: firebaseMVP22,
              }),
            );
          }
        })
        .then(() => {
          setIsProvisioning(false);
          // Force a reload of the app so that the user public data is loaded in correctly.
          // TODO: in future, we could manually retrigger this data reload, but for now this is the best solution
          // to avoid missing public user data.
          // This is because the public user data is loaded as soon as one logs in, when it has not been provisioned yet!
          window.location.reload();
        })
        .catch((error) => {
          setIsProvisioning(false);
          setProvisioningFailed(true);
        });
    },
    [auth, dispatch, firebaseMVP22],
  );
  const handleForceReload = React.useCallback<
    NotProvisionedProps['handleProvisioning']
  >((event) => {
    event.preventDefault();
    window.location.reload();
    return false;
  }, []);

  return (
    <NotProvisioned
      isProvisioning={isProvisioning}
      provisioningFailed={provisioningFailed}
      justLoggedIn={justLoggedIn}
      handleProvisioning={handleProvisioning}
      handleGoBack={handleGoBack}
      handleForceReload={handleForceReload}
    />
  );
};

export { NotProvisionedContainer as NotProvisioned };
